import { render, staticRenderFns } from "./LoanReminderPopup.vue?vue&type=template&id=aacbdb82&scoped=true"
import script from "./LoanReminderPopup.vue?vue&type=script&lang=js"
export * from "./LoanReminderPopup.vue?vue&type=script&lang=js"
import style0 from "./LoanReminderPopup.vue?vue&type=style&index=0&id=aacbdb82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacbdb82",
  null
  
)

export default component.exports